<div class="d-flex justify-center align-center h-full p-3">
    <mat-card class="w-full" style="max-width: 900px;">
        <mat-card-header></mat-card-header>
        <mat-card-content class="p-4">
            <div class="layout-grid cols-2 gap-4">
                <!-- Columna de Logos -->
                <div class="flex-column align-center">
                    <div class="w-full d-flex justify-start">
                        <img ngSrc="SAT_provedor_autorizado.png" priority width="80" height="80"
                            alt="SAT Proveedor Autorizado">
                    </div>
                    <div class="mt-n5">
                        <img ngSrc="ntlink_world.png" priority width="350" height="350" alt="NtLink World Logo"
                            style="margin-top: -50px;">
                    </div>
                    <div class="text-center magistral" style="margin-top: -50px;">
                        <h4><span class="mat-primary-text">Portal Web Service</span></h4>
                    </div>
                </div>

                <!-- Columna de Formulario -->
                <div class="flex-column">
                    <div class="d-flex justify-between align-center mb-3">
                        <h4><span class="mat-primary-text magistral">Sistema NtLink</span></h4>
                        <div class="d-flex gap-2">
                            <app-climate-toggle></app-climate-toggle>
                            <app-palette-picker></app-palette-picker>
                        </div>
                    </div>

                    <form #loginForm="ngForm" (submit)="login()" class="flex-column">
                        <mat-divider class="my-3"></mat-divider>

                        @if (!loginValid) {
                            <mat-error class="mb-2">
                                El usuario y contraseña no son correctos!.
                            </mat-error>
                        }

                        <mat-form-field appearance="outline" class="w-full mt-4">
                            <mat-label>Usuario</mat-label>
                            <input matInput placeholder="Usuario" [(ngModel)]="user" name="username" required>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Contraseña</mat-label>
                            <input matInput [type]="hidePassword() ? 'password' : 'text'" placeholder="Contraseña"
                                [(ngModel)]="password" name="password" required>
                            <button mat-icon-button matSuffix type="button"
                                (click)="togglePasswordVisibility(); $event.preventDefault()"
                                [attr.aria-label]="hidePassword() ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                                [attr.aria-pressed]="!hidePassword()">
                                <mat-icon>{{ hidePassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
                            </button>
                        </mat-form-field>

                        <div class="d-flex justify-center gap-3 mt-4">
                            <button mat-raised-button color="primary" type="submit" [disabled]="loading()">
                                @if (loading()) {
                                    <mat-progress-spinner mode="indeterminate" diameter="20" class="button-spinner"></mat-progress-spinner>
                                } @else {
                                    Iniciar Sesión
                                }
                            </button>
                            <button mat-raised-button color="accent" type="button" [disabled]="loading()"
                                (click)="router.navigate(['register'])">Registrarse</button>
                        </div>
                    </form>
                </div>
            </div>
        </mat-card-content>
        <mat-card-footer class="p-3 text-sm text-center opacity-25">
            Copyright © <a href="https://ntlink.com.mx" rel="noopener noreferrer" target="_blank" title="NTLINK"
                class="text-reset">NTLINK</a> {{year}} - V {{ version }} - <a
                href="https://ntlink.com.mx/aviso-privacidad" rel="noopener noreferrer" target="_blank"
                title="AVISO DE PRIVACIDAD" class="text-reset">AVISO DE PRIVACIDAD</a>
        </mat-card-footer>
    </mat-card>
</div>